// index.js
// Entry point for the Home Page

import HomePage from "./HomePage"; // Corrected casing


export default function Index() {
  console.log("Rendering HomePage"); // Log to track rendering

  return (
    <>
      {/* Render the Home Page */}
      <HomePage />
    </>

    
  );
}